import supabase from "./supabase";

/**
 * Sends a partnership request email to the admin.
 */
export async function sendPartnershipRequest({
  firstName,
  lastName,
  institution,
  email,
}: {
  firstName: string;
  lastName: string;
  institution: string;
  email: string;
}): Promise<{ success: boolean; error?: string }> {
  try {
    const fullName = `${firstName} ${lastName}`;
    const subject = "New Partnership Demo Request";
    const content = `
      <h2>New Partnership Demo Request</h2>
      <p><strong>Name:</strong> ${fullName}</p>
      <p><strong>Institution:</strong> ${institution}</p>
      <p><strong>Email:</strong> ${email}</p>
    `;

    const { error } = await supabase.functions.invoke("sendemail", {
      body: JSON.stringify({
        email: email,
        name: fullName,
        subject: subject,
        content: content,
      }),
      method: "POST",
    });

    if (error) {
      throw new Error(`HTTP error! Status: ${error}`);
    }

    return { success: true };
  } catch (error) {
    console.error("Error sending partnership request:", error);
    return { success: false, error: (error as Error).message };
  }
}
